import React from 'react'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Button, TextField } from '@mui/material'
import placeholder from 'config/placeholder'
import {
  StackItemTextField,
  useStyles as textFieldStyles,
} from 'ui/shorthands/StackItemTextField'
import { StackItem } from 'ui/layout/StackItem'
import postalCodeToAddress, {
  transformToNumber,
} from 'ui/utils/PostalCodeToAddress'

const ApplicantAddressInputForm: React.FC<{
  required?: boolean
}> = ({ required }) => {
  const { t } = useTranslation()

  const {
    control,
    setValue,
    getValues,
    trigger,
    setError,
    formState: { errors },
  } = useFormContext()
  const { classes, cx } = textFieldStyles()

  const setAddressHandler = () => {
    if (!errors.applicant_postal_code) {
      const postalCode = transformToNumber(getValues('applicant_postal_code'))
      postalCodeToAddress(postalCode)({
        success: (address) => {
          setValue('applicant_postal_code', postalCode)
          setValue(
            'applicant_address',
            [address.prefecture, address.city, address.area].join('')
          )
          trigger('applicant_address')
        },
        notFound: () =>
          setError('applicant_postal_code', {
            type: 'not_found',
            message: t('該当する番号が見つかりませんでした'),
          }),
      })
    }
  }

  return (
    <>
      <StackItem required={required} label={t('郵便番号')}>
        <Box display="flex">
          <span className={classes.firstInput}>
            <Controller
              name={'applicant_postal_code'}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  placeholder={placeholder().postal_code}
                  error={!!errors?.applicant_postal_code}
                  helperText={errors?.applicant_postal_code?.message}
                  InputProps={{
                    className: cx(
                      required && !field?.value && classes.required
                    ),
                  }}
                />
              )}
            />
          </span>
          <Button
            style={{ alignSelf: 'center' }}
            variant="contained"
            color="primary"
            onClick={setAddressHandler}
            disabled={!!errors.applicant_postal_code}
          >
            {t('住所入力')}
          </Button>
        </Box>
      </StackItem>
      <StackItemTextField
        name={'applicant_address'}
        label={t('住所')}
        placeholder={placeholder().address}
        errorMessage={errors?.applicant_address?.message}
        control={control}
        fullWidth
        required={required}
      />
    </>
  )
}

export default ApplicantAddressInputForm
